<template>
  <div class="title-label">
    <p class="content-label">
      <slot>未命名标题</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "TitleLabel"
};
</script>

<style lang="less" scoped>
.title-label {
  box-sizing: border-box;
  border-left: 0.5rem solid #58d9f9;
  height: 1.2rem;
  line-height: 1.2rem;
  margin-bottom: 0.625rem;
  margin-top: 1.25rem;
}

.content-label {
  margin: 0;
  padding-left: 0.3rem;
  font-size: 0.875rem;
  font-weight: bold;
  text-align: left;
  color: #4988d6;
}
</style>
